module.exports = "data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0OCA0OCI+PHBhdGggZmlsbD0iI0M1Q0FFOSIgZD0iTTQyIDQySDZWOWwxOC03IDE4IDd6Ii8+PHBhdGggZmlsbD0iIzlGQThEQSIgZD0iTTYgNDJoMzZ2Mkg2eiIvPjxwYXRoIGZpbGw9IiNCRjM2MEMiIGQ9Ik0yMCAzNWg4djloLTh6Ii8+PHBhdGggZD0iTTMxIDI3aDZ2NWgtNnptLTEwIDBoNnY1aC02em0tMTAgMGg2djVoLTZ6bTIwIDhoNnY1aC02em0tMjAgMGg2djVoLTZ6bTIwLTE2aDZ2NWgtNnptLTEwIDBoNnY1aC02em0tMTAgMGg2djVoLTZ6bTIwLThoNnY1aC02em0tMTAgMGg2djVoLTZ6bS0xMCAwaDZ2NWgtNnoiIGZpbGw9IiMxNTY1QzAiLz48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./assets/images/cloze/department.svg
// module id = 369
// module chunks = 0